import { TaroCanvas } from './canvas';
import { TaroContext2d } from './context';
import { createModule } from '../create-canvas-module';

export const taroCanvasModule = createModule(TaroCanvas, TaroContext2d);
